import React from "react"
import moment from 'moment';
import { FolderIcon } from './Icon';
import { ImageView } from "./ImageView";

const formatFileSize = (bytes) => {
    if (bytes == null || isNaN(bytes)) return null;
    if (bytes === 0) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1) + ' ' + units[i];
};

const formatDate = (date) => {
    if (!date) return null;
    return moment(date).format('M/D/YYYY');
};

export const CardTable = ({ dataSource, selectedRowKeys, children, onRow, onDropOnFolder }) => {

    const handleDragStart = (e, item) => {
        e.dataTransfer.setData('text/plain', JSON.stringify({ key: item.key, id: item.id, name: item.name, isFolder: item.isFolder }));
        e.dataTransfer.effectAllowed = 'move';
        e.currentTarget.classList.add('file-dragging');
    };

    const handleDragEnd = (e) => {
        e.currentTarget.classList.remove('file-dragging');
    };

    const handleDragOverFolder = (e, item) => {
        if (!item.isFolder || item.isSystem) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        e.currentTarget.classList.add('folder-drop-target');
    };

    const handleDragLeaveFolder = (e) => {
        e.currentTarget.classList.remove('folder-drop-target');
    };

    const handleDropOnFolder = (e, item) => {
        e.preventDefault();
        e.currentTarget.classList.remove('folder-drop-target');
        try {
            const data = JSON.parse(e.dataTransfer.getData('text/plain'));
            if (data && !data.isFolder && data.key !== item.key && onDropOnFolder) {
                onDropOnFolder(data, item);
            }
        } catch (err) {
            // ignore parse errors
        }
    };

    const getMeta = (item) => {
        if (item.isFolder) {
            const count = item.nodes?.length ?? 0;
            if (count === 0) return 'Empty folder';
            return `${count} item${count !== 1 ? 's' : ''}`;
        }
        const parts = [];
        const date = formatDate(item.modified_date || item.created_date);
        if (date) parts.push(date);
        const size = formatFileSize(item.size);
        if (size) parts.push(size);
        return parts.join('  ·  ');
    };

    return (
        <div className="file-management-cards">
            {dataSource.length === 0 ? (
                <div className="cards-empty-state">
                    No files found
                </div>
            ) : dataSource.map(item => {
                const isSelected = !!selectedRowKeys.find(i => i.key === item.key)
                const meta = getMeta(item);
                return (
                    <div
                        key={item.key}
                        className={`file-card${isSelected ? ' file-card-selected' : ''}`}
                        draggable={!item.isFolder && !item.isSystem}
                        onDragStart={(e) => handleDragStart(e, item)}
                        onDragEnd={handleDragEnd}
                        onDragOver={(e) => handleDragOverFolder(e, item)}
                        onDragLeave={handleDragLeaveFolder}
                        onDrop={(e) => handleDropOnFolder(e, item)}
                        onDoubleClick={(e) => {
                            onRow(item).onDoubleClick(e)
                        }}
                        onClick={(e) => {
                            onRow(item).onClick(e)
                        }}
                        onContextMenu={(e) => {
                            onRow(item).onContextMenu(e)
                        }}
                    >
                        <div className="card-icon">
                            {item.isFolder ? (
                                <FolderIcon isOpen={false} isSystem={item.isSystem} ischecked={isSelected} size={52} />
                            ) : (
                                <ImageView item={item} isSelected={isSelected} />
                            )}
                        </div>
                        <div className="card-name" title={item.name || item.title}>
                            {item.name || item.title}
                        </div>
                        {meta && <div className="card-meta" title={meta}>{meta}</div>}
                    </div>
                )
            })}
        </div>
    )
}